
const { stripe_publishable_key, donation_test_mode } = drupalSettings;

const stripe = Stripe(stripe_publishable_key);

const STRIPE_CREATE_CHECKOUT_API_URL = "/api/rspca_donation/stripe/create_checkout";

const STRIPE_SUCCESS_URL = "/payment-success?session_id={CHECKOUT_SESSION_ID}";
const STRIPE_CANCEL_URL = "/donate";

// const stripLogo = (`
//   <svg width="69" height="30" viewBox="0 0 69 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <path fill-rule="evenodd" clip-rule="evenodd" d="M37.3445 3.97992L32.5524 5.03862V1.03909L37.3445 0V3.97992ZM47.3103 6.19533C45.4393 6.19533 44.2365 7.09718 43.5683 7.72456L43.3201 6.50902H39.1198V29.3691L43.8929 28.33L43.912 22.7816C44.5993 23.2914 45.6111 24.0168 47.2913 24.0168C50.7087 24.0168 53.8208 21.1936 53.8208 14.9786C53.8017 9.29301 50.6515 6.19533 47.3103 6.19533ZM46.1649 19.7034C45.0384 19.7034 44.3702 19.2917 43.912 18.782L43.8929 11.5083C44.3893 10.9398 45.0766 10.5476 46.1649 10.5476C47.9022 10.5476 49.105 12.5474 49.105 15.1157C49.105 17.7429 47.9213 19.7034 46.1649 19.7034ZM68.8655 15.1747C68.8655 10.1556 66.4981 6.19533 61.9733 6.19533C57.4294 6.19533 54.6801 10.1556 54.6801 15.1355C54.6801 21.0367 57.9258 24.0168 62.5843 24.0168C64.8562 24.0168 66.5745 23.4874 67.8728 22.7424V18.8213C66.5745 19.4879 65.0853 19.8996 63.1952 19.8996C61.3433 19.8996 59.7014 19.233 59.4913 16.9196H68.8274C68.8274 16.8117 68.8342 16.567 68.8421 16.2849L68.8421 16.2832L68.8421 16.2827V16.2825L68.8422 16.2821V16.282V16.2818C68.8529 15.8979 68.8655 15.4454 68.8655 15.1747ZM59.4339 13.312C59.4339 11.0966 60.7512 10.1751 61.954 10.1751C63.1187 10.1751 64.3596 11.0966 64.3596 13.312H59.4339ZM32.5522 6.52861H37.3444V23.6835H32.5522V6.52861ZM27.1114 6.52866L27.4169 7.97947C28.5433 5.86207 30.7771 6.29339 31.388 6.52866V11.0379C30.7962 10.8223 28.8869 10.5478 27.7605 12.0574V23.6835H22.9875V6.52866H27.1114ZM17.8705 2.27421L13.212 3.2937L13.1929 18.9978C13.1929 21.8994 15.3122 24.0364 18.1378 24.0364C19.7034 24.0364 20.8489 23.7423 21.4789 23.3894V19.4095C20.868 19.6643 17.8514 20.5662 17.8514 17.6646V10.7046H21.4789V6.52862H17.8514L17.8705 2.27421ZM6.58741 10.4497C5.57553 10.4497 4.96458 10.7438 4.96458 11.5084C4.96458 12.3433 6.01603 12.7105 7.32047 13.1661C9.44702 13.9089 12.2459 14.8864 12.2578 18.5076C12.2578 22.017 9.5276 24.0364 5.55644 24.0364C3.91452 24.0364 2.11986 23.7031 0.344292 22.9189V18.2528C1.94803 19.1546 3.97179 19.8212 5.55644 19.8212C6.6256 19.8212 7.38928 19.5271 7.38928 18.6253C7.38928 17.7005 6.24949 17.2778 4.87345 16.7675C2.77783 15.9904 0.134277 15.0101 0.134277 11.7437C0.134277 8.27352 2.71171 6.19533 6.58741 6.19533C8.17206 6.19533 9.73761 6.4502 11.3223 7.09718V11.7045C9.87126 10.9007 8.03841 10.4497 6.58741 10.4497Z" fill="white"/>
//   </svg>
// `);
const stripLogo = (`
  <div class='flex justify-center items-center'>
    <span class='mr-small'>
      <svg width="30px" height="30px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" d="M896 324.096c0-42.368-2.496-55.296-9.536-68.48a52.352 52.352 0 0 0-22.144-22.08c-13.12-7.04-26.048-9.536-68.416-9.536H228.096c-42.368 0-55.296 2.496-68.48 9.536a52.352 52.352 0 0 0-22.08 22.144c-7.04 13.12-9.536 26.048-9.536 68.416v375.808c0 42.368 2.496 55.296 9.536 68.48a52.352 52.352 0 0 0 22.144 22.08c13.12 7.04 26.048 9.536 68.416 9.536h567.808c42.368 0 55.296-2.496 68.48-9.536a52.352 52.352 0 0 0 22.08-22.144c7.04-13.12 9.536-26.048 9.536-68.416V324.096zm64 0v375.808c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56V324.032c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448 20.864-11.136 41.6-17.088 98.56-17.088H795.84c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384 11.136 20.864 17.088 41.6 17.088 98.56z"/><path fill="#fff" d="M64 320h896v64H64v-64zm0 128h896v64H64v-64zm128 192h256v64H192z"/></svg>
      </span>
    <span class='text-lg leading-none font-semibold'>Credit card</span>
  </div>
`);

async function embedStripeCheckout(data, element) {
  let request = {
    "ui_mode": "embedded",
    "email": data.your_details.email,
    "return_url": `${window.location.protocol}//${window.location.host}${STRIPE_SUCCESS_URL}`,
    "amount": data.donation_details.amount,
    "meta_data": {...data.your_details, ...data.donation_details},
    "mode": data.donation_details.frequency == 'once' ? 'payment' : 'subscription'
  }

  const fetchClientSecret = async () => {
    const response = await fetch(STRIPE_CREATE_CHECKOUT_API_URL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    
    let responseJSON = await response.json();

    return responseJSON.data.client_secret;
  };

  const checkout = await stripe.initEmbeddedCheckout({
    fetchClientSecret,
  });

 
  checkout.mount(element);

  return checkout;
}

const attachStripeButton = (element, data) => {
  let stripeButton = $("<button/>", { html: stripLogo, class: 'stripe-button', 'type': 'button' });

  stripeButton.on("click", async function(e) {
    showStripePopup();
    
    let checkout = await embedStripeCheckout(data, "#stripe-embed-container");

    $("#stripe-popup").on('click', '.close', function (e) {
      e.preventDefault();
      checkout.destroy();
      $(this).closest('.popup').fadeOut();
      $("body").removeClass("no-scrolling");
    })
  });
  
  $(element).append(stripeButton);
}


const showStripePopup = () => {
  $("body").find("#stripe-popup").remove();
  $("body").addClass("no-scrolling");
  
  const popupHTML = (`
    <div class='popup popup-wrapper' id="stripe-popup">
      <div class='container-small popup-inner-container'>
        <a class='close' href='#'><i class='icon icon-x'></i></a>  
        <div class='' id="stripe-embed-container"></div>
      </div>
    </div>`
  );
  
  $("body").append(popupHTML);

  setTimeout(() => {
    $("body").find('#stripe-popup')
      .fadeIn()
      .css({ 'display': 'flex', 'flex-direction': 'row' });;
  }, alert.delay);
}

export {
  attachStripeButton
}
